/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryResponse,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsPathParams,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryParams,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials401,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials500,
} from "../../types/individualPaymentLookupsController/GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials.ts";

function getGetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsUrl(
  courseRegistrationId: GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsPathParams["courseRegistrationId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/course-registrations/${courseRegistrationId}/course-financials` as const,
  };
  return res;
}

/**
 * @description Respeita vigência (StartDate/EndDate), restrição por turma e empresa (curso ou CourseCompanies). A empresa do usuário autenticado sobrepõe 'companyId'. Migrado do legado IndividualPayment/CourseFinancialDropDown. **(Requer Authorization para autenticação)**
 * @summary Dropdown de planos financeiros ativos e vigentes do curso da matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/course-registrations/:courseRegistrationId/course-financials}
 */
export async function getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials(
  courseRegistrationId: GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsPathParams["courseRegistrationId"],
  params?: GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials401
      | GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsUrl(
      courseRegistrationId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
